import React, { useState } from 'react';
import { FacebookEmbed } from 'react-social-media-embed';

import Loading from '../../core/Loading';
import { StyledWrapper } from './style';

const Instagram = () => {
  const [loading, setLoading] = useState(true);

  const onLoaded = () => {
    setLoading(false);
  };

  return (
    <StyledWrapper>
      {loading && <Loading />}
      <FacebookEmbed
        url="https://www.facebook.com/atresmediacom/"
        width={50}
        onSuccess={onLoaded}
      />
    </StyledWrapper>
  );
};

export default Instagram;

